import { rows, DataGrid } from "colbi_web_ui/lib/components";
import { parseFilter } from "colbi_web_ui/lib/utils";
import App from "../controllers/App/App";
import AppNewLogic from "../controllers/App/AppNewLogic";
import { parseSort } from "colbi_web_ui/lib/utils/queryUtils";
import { DownloadButton } from "../components/DownloadButton/DownloadButton";
import { getConfigVariable } from "../config/config";
import { hasModule } from "../utils/utils";

const AuditSummaryController = (props) => {
    const { modules } = props;
    const modifiedProps = { ...props, hideNewMenu: true, hasHeroBanner: true, }
    const Controller = hasModule(modules, "new_navigation") ? AppNewLogic : App;
    return <Controller {...modifiedProps} />;
};

const queries = (args = {}) => {
    return [
        {
            resource: "nc_audit_execution_summary",
            args: {
                projectId: args.projectId,
                fiscalYear: args.fiscalYear,
                importId: args.importId,
                page: parseInt(args.page || 0),
                pageSize: parseInt(
                    args.pageSize || getConfigVariable("REACT_APP_DEFAULT_PAGE_SIZE"),
                ),
                locale: args.locale,
                sort: args.sort ? { type: "[SortInput!]", value: parseSort(args.sort) } : undefined,
                filter: args.filter
                    ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                    : undefined,
            },
            body: `__typename, items{ ...nc_audit_execution_summary }, hasMore, total, filters(projectId:$projectId,fiscalYear:$fiscalYear){ prop, name, type, list, disableOperators,mandatory }`,
            downloadable: true,
            xlsxTranslation: "nc_audit_execution_summary",
            //We had to do two minor changes to the way we did pagination.
            //The following variable allows that in fetchAction.js
            isDatagridReq: true,
        },
        {
            resource: "data_files_types_present",
            args: {
                projectId: args.projectId,
            },
            body: "hasSource, hasLegal",
        },
    ];
};

const auditSummaryByFile = (path, navigation, exact, title) => ({
    path,
    navigation,
    component: AuditSummaryController,
    queries,
    exact,
    title,
    hasSource: "query(1).hasSource",
    hasLegal: "query(1).hasLegal",
    headerComponentConfigs: {
        showButton: true,
        label: "Download",
        type: "single",
    },
    headerComponents: [{ component: DownloadButton }],
    navByImportId: true,
    components: [
        {
            component: DataGrid,
            props: {
                id: "results",
                items: "query(0).list",
                cardKey: "param(id)",
                card: rows.CellCard,
                sort: "param(sort)",
                filter: "param(filter)",
                availableFilters: "query(0).filters",
                metadata: "query(0).metadata",
                page: "param(page)",
                status: "status(0)",
                pageSize: "param(pageSize)",
                pageDefault: 10,
                footer: "query(0).footer",
                header: "query(0).header",
                adjustStickyTop: true,
            },
        },
    ],
});

export default auditSummaryByFile;
